import React from 'react';
import glamorous from 'glamorous';

import logo from './logo.svg';
import logoWhite from './logo-white.svg';
import logoIcon from './logo-icon.svg';
import logoIconWhite from './logo-icon-white.svg';

const style = props => ({
  height: 40,

  userSelect: 'none',
  ...props.glamStyle,
});

const baseStyle = style({});
const Image = glamorous.img(baseStyle, style);

const getLogoSrc = (isIcon, white) => {
  if (isIcon) {
    return white ? logoIconWhite : logoIcon;
  }

  return white ? logoWhite : logo;
};

const Logo = ({ style, white, isIcon, ...props }) => (
  <Image
    {...props}
    glamStyle={style}
    src={getLogoSrc(isIcon, white)}
  />
);

export default Logo;



// WEBPACK FOOTER //
// ./src/assets/Logo/Logo.js